export const HUBSPOT_FORM_SOURCE = {
  modal: "modal",
  landing: "landing",
};
